import { Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { ChatMessageProps } from '~/common/types/ChatMessage';
import { ChatStep } from '~/components/ChatStep/ChatStep';

import { QuoteComplianceDisplay } from './components/QuoteComplianceDisplay/QuoteComplianceDisplay';
import { useQuoteComplianceStep } from './IntakeQuoteComplianceStep.hooks';

export const IntakeQuoteComplianceStep = ({ role, createdBy }: ChatMessageProps) => {
  const { t: tIntake } = useTranslation(I18nNamespace.intake);
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeQuoteComplianceStep' });

  const { complianceData, loading } = useQuoteComplianceStep();

  return (
    <ChatStep
      title={tIntake('IntakeChatStep.assistant')}
      role={role}
      createdBy={createdBy}
      message={loading ? t('analyzingMessage') : t('completedMessage')}
    >
      {loading && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      )}

      {complianceData && !loading && <QuoteComplianceDisplay complianceResult={complianceData} />}
    </ChatStep>
  );
};
